module.exports = __webpack_public_path__ + "img/contactdetailsicon.c283d798.svg";